import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.8 2.8v18.4h14.4V9c0-2.9-.507-4.261-1.223-4.977S15.9 2.8 13 2.8zM3 23h18V9c0-6-2-8-8-8H3zm13.5-12.6h-9V8.6h9zm-9 5h9v-1.8h-9z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentOutlinedSize24Glyph.displayName = 'DocumentOutlinedSize24Glyph';
